import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoHomeNavButtonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-home-nav-button',
  templateUrl: 'co-home-nav-button.html'
})
export class CoHomeNavButtonComponent {

  notHome: boolean;
  constructor( private navCtrl : NavController, private state: AppState) {
    // this.navCtrl.length() > 1 ? this.notHome = true : this.notHome = false;
    // console.log(this.navCtrl.length(), typeof this.navCtrl, this.navCtrl);
  }

  private goToHomeScreen(){
    // console.log(this.navCtrl.length(), typeof this.navCtrl, this.navCtrl);
    // for (let x = this.navCtrl.length(); x > 2; x--){
    //   this.navCtrl.pop();
    // }


    // this.navCtrl.popTo(this.navCtrl.getByIndex(1)); BEFORE CHANGES WERE MADE
    if (this.state.homeScreen) {
      this.navCtrl.popTo(this.navCtrl.getByIndex(this.state.homeScreen));
    } else {
      this.navCtrl.popToRoot();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-home-nav-button/co-home-nav-button.ts